module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Fork-spoon-knife-931bf07b194a23c7a299c0db73b1b9a9.svg";